import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import countryData from "../data/countryCode.json"; // Make sure this path is correct

const EditOperatorModal = ({ show, onHide, operator, onChange, onSave }) => {
    const [countries, setCountries] = useState([]);

    useEffect(() => {
        setCountries(countryData);
    }, []);

    const handleCountryChange = (e) => {
        const selectedCountry = e.target.value;
        const matched = countries.find((c) => c.country === selectedCountry);
        const updatedCode = matched ? matched.code : "";

        onChange({
            ...operator,
            country: selectedCountry,
            code: updatedCode,
        });
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title className="text-h1">Edit Operator</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {operator && (
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Operator ID</Form.Label>
                            <Form.Control
                                type="number"
                                value={operator.operatorId}
                                onChange={(e) =>
                                    onChange({ ...operator, operatorId: parseInt(e.target.value) })
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Operator Name</Form.Label>
                            <Form.Control
                                type="text"
                                value={operator.operatorName}
                                onChange={(e) =>
                                    onChange({ ...operator, operatorName: e.target.value })
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Country</Form.Label>
                            <Form.Select
                                value={operator.country}
                                onChange={handleCountryChange}
                            >
                                <option value="">Select Country</option>
                                {countries.map((c, idx) => (
                                    <option key={idx} value={c.country}>
                                        {c.country}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Code</Form.Label>
                            <Form.Control
                                type="text"
                                value={operator.code}
                                disabled
                                className="bg-light"
                            />
                        </Form.Group>
                    </Form>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} className="py-1">
                    Cancel
                </Button>
                <Button variant="primary" onClick={onSave} className="py-1">
                    Save Changes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditOperatorModal;
